<template>
  <div v-if="event && tickets && $route.query.event_id">
    <div class="mb-8 flex flex-col md:flex-row justify-between md:items-center bg-white">
      <div class="flex flex-col">
        <div class="flex items-center leading-none">
          <span
            class="mr-2 text-xl"
          >Neue Bestellung für {{event.title}} am {{formatDateTimeForHuman(event.start_date)}} Uhr</span>
        </div>
      </div>
    </div>

    <form @submit.prevent="place">
      <div
        class="p-8 -mx-8 sm:mx-0 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6 border border-gray-100 shadow-lg rounded-lg"
      >
        <div class="sm:col-span-4 text-xl">Angaben zur Bestellung</div>

        <basic-input
          v-model="details.first_name"
          class="sm:col-span-6 md:col-span-3"
          label="Vorname"
          placeholder="Vorname"
          required
        />
        <basic-input
          v-model="details.last_name"
          class="sm:col-span-6 md:col-span-3"
          label="Nachname"
          placeholder="Nachname"
          required
        />
        <basic-input
          v-model="details.email"
          class="sm:col-span-6 md:col-span-3"
          label="E-Mail"
          placeholder="E-Mail"
          required
          type="email"
        />
        <date-picker
          v-model="details.available_until"
          class="sm:col-span-6 md:col-span-3 md:row-start-4"
          label="Bestellung gültig bis"
          placeholder="Bestellung gültig bis"
        />
      </div>

      <div class="mt-8 p-8 -mx-8 sm:mx-0 border border-gray-100 shadow-lg rounded-lg">
        <div class="sm:col-span-4 text-xl">Ticketauswahl</div>

        <div>
          <div class="pb-2 mt-8 mb-4 flex font-semibold justify-between border-b">
            <div class="w-2/6">Kategorie</div>

            <div class="w-2/6">Typ</div>

            <div class="w-1/6">Preis</div>

            <div class="w-1/6 text-right">Anzahl</div>
          </div>

          <div v-for="category in tickets.categories" :key="category.id">
            <div
              v-for="type in category.types"
              :key="type.id"
              class="py-4 flex justify-between items-center hover:bg-gray-100"
            >
              <div class="w-2/6">{{category.title}}</div>

              <div class="w-2/6 truncate">{{type.title}}</div>

              <div class="w-1/6 truncate">{{price(type.price_including_fees)}}</div>

              <div class="w-1/6 text-right">
                <basic-input type="number" placeholder="Anzahl" @input="addTickets(type, $event)" />
              </div>
            </div>
          </div>

          <div class="text-right mt-4 font-semibold">Total für {{count}} Tickets: {{price(amount)}}</div>

          <div class="text-right mt-6">
            <basic-button
              :disabled="!(count > 0) || loading"
              :loading="loading"
              type="submit"
              size="lg"
            >Bestellen</basic-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DatePicker from "@/components/basic/DatePicker";
import eventsCommerceClient from "@/api/commerce/events";
import eventsDiscoveryClient from "@/api/discovery/events";
import ordersClient from "@/api/commerce/orders";

import InteractsWithPrices from "@/mixins/InteractsWithPrices";
import InteractsWithDates from "@/mixins/InteractsWithDates";

import _sumBy from "lodash/sumBy";
import _forEach from "lodash/forEach";
import _times from "lodash/times";

import moment from "moment";

export default {
  components: { DatePicker },
  data() {
    return {
      details: {
        first_name: "",
        last_name: "",
        email: "",
        available_until: moment().add(10, "days").format("YYYY-MM-DD HH:mm:ss"),
      },
      event: null,
      tickets: null,
      items: {},
      loading: false,
      event_id: parseInt(this.$route.query.event_id),
    };
  },

  mixins: [InteractsWithPrices, InteractsWithDates],

  mounted() {
    eventsDiscoveryClient
      .show(this.event_id)
      .then(({ data }) => (this.event = data.data));
    eventsCommerceClient
      .show(this.event_id)
      .then(({ data }) => (this.tickets = data.data));
  },

  computed: {
    count() {
      let count = 0;

      _forEach(this.items, (item) => {
        count += item.count;
      });

      return count;
    },

    amount() {
      let amount = 0;

      _forEach(this.items, (item) => {
        amount += item.count * item.price;
      });

      return amount;
    },
  },

  methods: {
    addTickets(type, event) {
      const count = parseInt(event);

      if (isNaN(count) || count < 1) {
        this.$delete(this.items, type.id);
      } else {
        this.$set(this.items, type.id, {
          id: type.id,
          count: count,
          price: type.price_including_fees,
        });
      }
    },
    async place() {
      this.loading = true;

      let tickets = [];

      _forEach(this.items, (item) => {
        _times(item.count, () => {
          tickets.push({ type_id: item.id });
        });
      });

      try {
        let {
          data: { data: order },
        } = await ordersClient.create({
          event_id: this.event_id,
          tickets: tickets,
          channel: "online",
          available_until: this.details.available_until,
        });

        await ordersClient.update(order.id, this.details, order.signature);

        await ordersClient.place(
          order.id,
          { payment_type: "banktransfer" },
          order.signature
        );

        this.$toasted.success("Bestellung erfolgreich");

        this.$router.push({ name: "orders.order", params: { id: order.id } });
      } catch (error) {
        this.$toasted.global.error();
      }

      this.loading = false;
    },
  },
};
</script>